const DEFAULT_OPTIONS = {
    maxLength: 0,
    preserveLineBreaks: true,
    preserveWhitespace: false,
    listItemSeparator: "• ",
    decodeEntities: true,
    blockElements: [
        "div",
        "p",
        "br",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "li",
        "ul",
        "ol",
    ],
    trim: true,
};
const HTML_ENTITIES = {
    "&amp;": "&",
    "&lt;": "<",
    "&gt;": ">",
    "&quot;": '"',
    "&#39;": "'",
    "&apos;": "'",
    "&nbsp;": " ",
    "&euro;": "€",
    "&pound;": "£",
    "&yen;": "¥",
    "&copy;": "©",
    "&reg;": "®",
    "&trade;": "™",
    "&hellip;": "...",
    "&mdash;": "—",
    "&ndash;": "–",
    "&laquo;": "«",
    "&raquo;": "»",
    "&times;": "×",
    "&divide;": "÷",
};
const REGEX_CACHE = {
    htmlTags: /<[^>]*>/g,
    htmlEntities: /&[a-zA-Z0-9#]+;/g,
    whitespace: /\s+/g,
    multipleLineBreaks: /\n{3,}/g,
    leadingTrailingSpaces: /^\s+|\s+$/g,
    blockElementsStart: null,
    blockElementsEnd: null,
};
function decodeHtmlEntities(text) {
    return text.replace(REGEX_CACHE.htmlEntities, (entity) => {
        if (HTML_ENTITIES[entity]) {
            return HTML_ENTITIES[entity];
        }
        if (entity.startsWith("&#")) {
            const isHex = entity.startsWith("&#x");
            const numStr = entity.slice(isHex ? 3 : 2, -1);
            const num = parseInt(numStr, isHex ? 16 : 10);
            if (!isNaN(num) && num >= 0 && num <= 0x10ffff) {
                return String.fromCharCode(num);
            }
        }
        return entity;
    });
}
function buildBlockElementsRegex(blockElements) {
    if (!REGEX_CACHE.blockElementsStart) {
        const elements = blockElements.join("|");
        REGEX_CACHE.blockElementsStart = new RegExp(`<(${elements})\\b[^>]*>`, "gi");
        REGEX_CACHE.blockElementsEnd = new RegExp(`</(${elements})>`, "gi");
    }
}
function processBlockElements(html, options) {
    buildBlockElementsRegex(options.blockElements);
    let processed = html;
    if (REGEX_CACHE.blockElementsStart && REGEX_CACHE.blockElementsEnd) {
        processed = processed
            .replace(REGEX_CACHE.blockElementsStart, "\n$&")
            .replace(REGEX_CACHE.blockElementsEnd, "$&\n");
    }
    processed = processed
        .replace(/<br\s*\/?>/gi, "\n")
        .replace(/<li\b[^>]*>/gi, `\n${options.listItemSeparator}`)
        .replace(/<\/li>/gi, "")
        .replace(/<p\b[^>]*>/gi, "\n")
        .replace(/<\/p>/gi, "\n");
    return processed;
}
function normalizeWhitespace(text, options) {
    if (!options.preserveWhitespace) {
        text = text.replace(REGEX_CACHE.whitespace, " ");
    }
    if (!options.preserveLineBreaks) {
        text = text.replace(/\n/g, " ");
    }
    else {
        text = text.replace(REGEX_CACHE.multipleLineBreaks, "\n\n");
    }
    return text;
}
export function htmlToText(html, options = {}) {
    if (typeof html !== "string") {
        return "";
    }
    if (!html.trim()) {
        return "";
    }
    const config = {
        ...DEFAULT_OPTIONS,
        ...options,
    };
    let result = html;
    result = processBlockElements(result, config);
    result = result.replace(REGEX_CACHE.htmlTags, "");
    if (config.decodeEntities) {
        result = decodeHtmlEntities(result);
    }
    result = normalizeWhitespace(result, config);
    if (config.trim) {
        result = result.trim();
    }
    if (config.maxLength > 0 && result.length > config.maxLength) {
        result = result.substring(0, config.maxLength - 3) + "...";
    }
    return result;
}
export function stripHtmlTags(html) {
    if (typeof html !== "string") {
        return "";
    }
    return html.replace(REGEX_CACHE.htmlTags, "").trim();
}
export function extractTextPreview(html, maxLength, suffix = "...") {
    const text = htmlToText(html, {
        preserveLineBreaks: false,
        preserveWhitespace: false,
        trim: true,
    });
    if (text.length <= maxLength) {
        return text;
    }
    const truncated = text.substring(0, maxLength - suffix.length);
    const lastSpaceIndex = truncated.lastIndexOf(" ");
    if (lastSpaceIndex > maxLength * 0.8) {
        return truncated.substring(0, lastSpaceIndex) + suffix;
    }
    return truncated + suffix;
}
export function hasHtmlTags(text) {
    if (typeof text !== "string") {
        return false;
    }
    return REGEX_CACHE.htmlTags.test(text);
}
export default htmlToText;
